import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("unknown");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          localStorage.removeItem("cbm_cart");
          setStatus("paid");
          return;
        }
      } catch (e) {
        /* keep polling */
      }
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="flex min-h-screen items-center justify-center bg-[#FDFBF7] px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="hard-shadow-lg max-w-lg rounded-2xl border-2 border-[#0A0A0A] bg-white p-10 text-center"
      >
        {status === "checking" ? (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-[#FF2A54]" />
            <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight">Confirming your order</h1>
            <p data-testid="payment-status-text" className="mt-3 text-[#4A4A4A]">One sec — we&rsquo;re checking with Stripe.</p>
          </>
        ) : status === "paid" ? (
          <>
            <CheckCircle2 className="mx-auto h-12 w-12 text-[#FF2A54]" />
            <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight">Sweet! Order confirmed</h1>
            <p data-testid="payment-status-text" className="mt-3 text-[#4A4A4A]">
              Your treats are being packed. Keep an eye on your inbox for shipping details.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto h-12 w-12 text-[#FFD700]" />
            <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight">Payment processing</h1>
            <p data-testid="payment-status-text" className="mt-3 text-[#4A4A4A]">
              Your payment is still being processed. If you were charged, your order is safe — we&rsquo;ll email you shortly.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="back-to-store-link"
          className="hard-shadow hard-shadow-hover mt-8 inline-block rounded-full border-2 border-[#0A0A0A] bg-[#FFD700] px-8 py-3 font-display text-sm font-extrabold uppercase text-[#0A0A0A]"
        >
          Back to the store
        </Link>
      </motion.div>
    </main>
  );
}
